<template>
	<!--个人中心 -->
	<div class="tieziInfoBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<img src="../../assets/img/myicon/indexBgc02.png" alt="" class="backImg">
				<div class="headerQuery">
					<div class="arrImg" @click="backForum">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">个人中心</p>
					<div class="header_qk">
						<!-- <img src="../../assets/img/white_ellipsis.png" alt=""> -->
					</div>
				</div>
			</div>
		</van-sticky>
		<div class="navBar">
			<div  class="navBarBox" :class="navBarIndex == index ? 'active' : ''" @click="navbarFn(index)" v-for="(item,index) in navbar" :key="index">
				<span>{{item}}</span>
				<p></p>
			</div>
		</div>
		<!-- 帖子列表 -->
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
		<div class="navBarIdxBox" v-show="navBarIndex == 0 ? true : false">
			<div class="masageLists" 
				 v-for="(item,index) in forumCollectList" 
				 :key="index"
				 @touchstart="gotouchstart(item.collect_id)" 
				 @touchmove="gotouchmove" 
				 @touchend="gotouchend"
				 @click="onclikInfo(item.collect_id)"
			>
				<div class="massage_top">
					<div class="massage_top_left">
						<p>{{item.title}}</p>
					</div>
					
				</div>
				<div class="massage_footer">
					<div class="massage_footer_left">
						<img :src="$api.$BASE_URL_img + item.user_avatar" alt="">
						<span>{{item.category_name}}</span>
						<span class="timeInfo">{{formatDateTime(item.createtime)}}</span>
					</div>
					<div class="massage_footer_right">
						<img src="../../assets/img/ltxiaoxi.png" alt="消息图标" />
						<span>{{item.comment_num}}</span>
					</div>
				</div>
			</div>
			<div style="width:100%;margin-top:30%;text-align: center;">
				<img src="../../assets/img/data_null.png" alt="" width="80px" v-if="forumCollectList.length == 0 ? true : false">
			</div>
		</div>
		<!-- 发表帖子 -->
		<div class="navBarIdxBox" v-show="navBarIndex == 1 ? true : false">
			<div class="masageLists" 
				 v-for="(item,index) in myForumList" 
				 :key="index"
				 @click="onclikInfo(item.id)"
			>
				<div class="massage_top">
					<div class="massage_top_left">
						<p>{{item.title}}</p>
					</div>
					
				</div>
				<div class="massage_footer">
					<div class="massage_footer_left">
						<img :src="$api.$BASE_URL_img + item.user_avatar" alt="">
						<span>{{item.category_name}}</span>
						<span class="timeInfo">{{formatDateTime(item.createtime)}}</span>
					</div>
					<div class="massage_footer_right">
						<img src="../../assets/img/ltxiaoxi.png" alt="消息图标" />
						<span>{{item.comment_num}}</span>
					</div>
				</div>
			</div>
			<div style="width:100%;margin-top:30%;text-align: center;">
				<img src="../../assets/img/data_null.png" alt="" width="80px" v-if="myForumList.length == 0 ? true : false">
			</div>
		</div>
		<!-- 最近浏览帖子 -->
		<div class="navBarIdxBox" v-show="navBarIndex == 2 ? true : false">
			<div class="masageLists" 
				 v-for="(item,index) in forumBrowsing" 
				 :key="index" v-if="forumBrowsing.length != 0 ? true : false"
				 @click="onclikInfo(item.f_id)"
			>
				<div class="massage_top">
					<div class="massage_top_left">
						<p>{{item.title}}</p>
					</div>
					
				</div>
				<div class="massage_footer">
					<div class="massage_footer_left">
						<img :src="$api.$BASE_URL_img + item.user_avatar" alt="">
						<span>{{item.category_name}}</span>
						<span class="timeInfo">{{formatDateTime(item.createtime)}}</span>
					</div>
					<div class="massage_footer_right">
						<img src="../../assets/img/ltxiaoxi.png" alt="消息图标" />
						<span>{{item.comment_num}}</span>
					</div>
				</div>
			</div>
			<div style="width:100%;margin-top:30%;text-align: center;">
				<img src="../../assets/img/data_null.png" alt="" width="80px" v-if="forumBrowsing.length == 0 ? true : false">
			</div>
		</div>
		</van-pull-refresh>
		<div class="luntantost" v-show="addHfShow">
			<div class="luntantostbgc">
				<div v-for="(item,idx) in addHf" @click.stop="addHfFn()">{{item}}</div>
			</div>
		</div>
		<div class='mask' v-show="addHfShow" @click="hideTost01"></div>
	</div>
</template>

<script>
	import {Toast} from 'vant';
	export default{
		data(){
			return{
				navBarIndex: 0,
				navbar:["收藏帖子","发表帖子","最近浏览帖子"],
				forumCollectList: [],
				myForumList:[],
				forumBrowsing:[],
				addHf:['取消收藏'],
				addHfShow: false,
				timeOutEvent: 0,
				isLoading:false,
			}
		},
		created() {
			this.forum_collect_list(this.navBarIndex)
		},
		methods:{
			onRefresh() {				setTimeout(() => {					Toast('已获取到最新数据');					this.forum_collect_list(this.navBarIndex)					this.isLoading = false;				}, 1000);			},
			hideTost01(){
				this.addHfShow = !this.addHfShow
			},
			addHfFn(){
				// 取消收藏
				this.$axios.post(this.$api.collect_forum,{
					forum_id: this.clearHfId,
					type: 2
				}).then(res => {
					this.addHfShow = false;
					Toast(res.data.msg);
					this.forum_collect_list(this.navBarIndex)
				})
			},
			gotouchstart(id) {
				this.clearHfId = id;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.addHfShow = true;
				}, 600); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend(id) {
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			// ------------------------------------------------------
			backForum(){
				this.$router.push('/forum')
			},
			navbarFn(data){
				this.navBarIndex = data
				console.log(data)
				if(this.navBarIndex == 0){
					this.forum_collect_list(this.navBarIndex)
				}else if(this.navBarIndex == 1){
					this.my_forum_list(this.navBarIndex)
				}else if(this.navBarIndex == 2){
					this.forum_browsing(this.navBarIndex)
				}
			},
			forum_collect_list(id){
				this.$axios.post(this.$api.forum_collect_list).then(res => {
					this.forumCollectList = res.data.data.reverse();
				})
			},
			my_forum_list(id){
				this.$axios.post(this.$api.my_forum_list).then(res => {
					this.myForumList = res.data.data.reverse();
				})
			},
			forum_browsing(id){
				this.$axios.post(this.$api.forum_browsing).then(res => {
					this.forumBrowsing = res.data.data.reverse();
				})
			},
			
			jumpHtgc(){
				this.$router.push({path: '/bookcity',query:{getSecondtab: 6,getFirstvaluetab: null,gettabArridx:6}})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			onclikInfo(id) {
				this.$router.push({path:'/tieziInfo',query:{tzxqInfoId: id}});
			}
		}
	}
</script>

<style lang="less" scoped>
	.tieziInfoBox{
		background-color: #fff;
		height: 100vh;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #fff;
			display: flex;
			// background: url(../../assets/img/myicon/indexBgc02.png) no-repeat 0% 88%;
			// background-size: 100%;
			position: relative;
			
			.backImg{
				position: absolute;
				bottom: 10px;
				left:0;
				width:100%;
			}
			
			.headerQuery {
				margin-top: 80px;
				padding: 0 20px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
				border-bottom: 1px solid #f0f0f0;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
		
				.header_qk {
					img {
						position: absolute;
						top: 50%;
						right: 16px;
						transform: translateY(-50%);
						width: 55px;
					}
				}
			}
		
		}
		//导航
		.navBar{
			padding: 20px;
			display: flex;
			background-color: #fff;
			position: fixed;
			width: calc(100vw - 40px);
			z-index: 100;
			.navBarBox {
				flex:1;
				text-align: center;
				font-size: 30px;/*px*/
				position: relative;
				span {
					line-height: 60px;
					display: inline-block;
					color: #3d3d3d;
				}
					
				p {
					width: 52%;
					height: 4px;
					position: absolute;
					bottom: 0px;
					left: 50%;
					transform: translateX(-50%);
					background-color: transparent;
					border-radius: 4px;
				}
					
			}
					
			div.active {
				p {
					background-color: #f4ce72;
				}
					
				span {
					// color: #fa7298;
					color: #404040;
					font-weight: 700;
				}
			}
		}
		
		.navBarIdxBox{
			margin-top: 80px;
		}
		//帖子列表
		.masageLists {
			margin: 0 16px;
			border-bottom: 1px solid #f0f0f0;/*px*/
			padding:20px 0;
			.massage_top {
				display: flex;
		
				.massage_top_left {
					font-size: 34px;/*px*/
					color: #000;
				}
			}
		
			.massage_footer {
				padding: 10px 0 5px;
				display: flex;
				.massage_footer_left{
					flex: 1;
					display: flex;
					flex-direction: row;
					align-items: center;
					
					img {
						vertical-align: middle;
						width: 40px;
						height:40px;
						box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
					}
					
					span {
						padding: 0 20px;
						font-size: 24px;/*px*/
						color:#a3a3a3;
					}
					.timeInfo {
						padding: 0;
						font-size: 24px;/*px*/
						color:#999999;
						span{
							padding-right: 10px;
						}
					}
				}
				.massage_footer_right{
					width: 100px;
					text-align: right;
					position: relative;
					img{
						width: 35px;
						padding-right: 10px;
						position: absolute;
						right: 20px;
						top: 50%;
						transform: translateY(-50%);
					}
					span{
						display: inline-block;
						padding-top: 5px;
					}
				}
				
		
				
			}
		}
	
		//弹窗
		.luntantost{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100vw;
			// height: 454px;
			background:url(../../assets/img/luntanImg.png) no-repeat;
			background-size: 100%;
			z-index: 100;
			.luntantostbgc{
				margin-top: 124px;
				z-index: 10000 !important;
				background:url(../../assets/img/cat.png) no-repeat #fff;
				background-size: 100%;
				div{
					line-height: 260px;
					text-align: center;
					color: #737373;
					font-size: 30px;/*px*/
					z-index: 1000 !important;
				}
				div.active{
					color: #ff4081;
				}
			}
			
		}
		.mask{
			position: fixed;
			top:0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background-color: rgba(0,0,0,.3);
		}
	}

</style>
